import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let tokenGetter = async () => null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };

export const api = axios.create({ baseURL: API, timeout: 90000 });
api.interceptors.request.use(async (cfg) => {
  const t = await tokenGetter();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return "Something went wrong. Please try again.";
};

export const PERSON = [
  { fill: "#F06292", text: "#B83268", tint: "#FDE7EF" },
  { fill: "#7C6CF2", text: "#5B4BD6", tint: "#ECE9FD" },
  { fill: "#2EC4B6", text: "#0F8C80", tint: "#DFF6F3" },
  { fill: "#F4B400", text: "#8A6000", tint: "#FDF3D6" },
];
export const pc = (color) => PERSON[(color ?? 1) % 4];

export const waUrl = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;
export const origin = () => window.location.origin;
export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
export const fmtDay = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
};
export const wkday = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-IN", { weekday: "short" });
export const rupee = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;

export const CAT_ICON = {
  milk: "🥛", dhobi: "👕", helper: "🧹", lpg: "🔥", kirana: "🏪", water: "💧", medicine: "💊",
  meals: "🍲", groceries: "🛒", school: "🎒", repair: "🔧", errand: "🏠",
};
export const SRC_ICON = { voice: "🎤", scan: "📷", type: "⌨️", meals: "🍲", setup: "✨" };
export const LANGS = ["English", "Hinglish", "हिंदी", "मराठी"];
export const REPEATS = [["none", "No repeat"], ["daily", "Daily"], ["weekly", "Weekly"], ["monthly", "Monthly"], ["every_n", "Every N days"]];

export const inviteText = (code) =>
  `Join our home on UnloadIt so we can share the housework 💜 ${origin()}/join?code=${code} Code: ${code}`;

export function compressImage(file, max = 1600) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const s = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * s);
      c.height = Math.round(img.height * s);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      resolve(c.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => reject(new Error("bad image"));
    img.src = url;
  });
}

export const vibrate = () => { try { navigator.vibrate && navigator.vibrate(15); } catch (e) { /* noop */ } };
